// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xApxg","left":"styles_left__3YG1u","right":"styles_right__3Okfr","alert":"styles_alert__1c-uG"};